import { TabView, TabPanel } from "primereact";
import ResultBox from "./ResultBox";
import StartListBox from "./StartListBox";


export default function SB_Tabs() {
    return (
        <div className="flex-1 rounded-xl bg-gray-100 p-2 bg-transparent" >
            <TabView className="h-full flex flex-col" panelContainerClassName="flex-1" >
                <TabPanel header="START LIST" className="flex-1" contentClassName="h-full">
                    <StartListBox />
                </TabPanel>
                <TabPanel header="RESULTS" className="flex-1" contentClassName="h-full">
                    <ResultBox />
                </TabPanel>
                <TabPanel header="RADIO CONTROL" className="flex-1" contentClassName="h-full">

                </TabPanel>
            </TabView>
        </div>
    )
}